import useActionsOnMapDrag from './useCurrentBounds';

export default useActionsOnMapDrag;
